var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"inline-block"}},[_c('canvas',{ref:"canvas",attrs:{"width":"500","height":"250"}}),_c('img',{ref:"icons",staticStyle:{"display":"none"},attrs:{"src":"/img/speedometer-icons.svg"},on:{"load":_vm.draw}})])}
var staticRenderFns = []

export { render, staticRenderFns }